export { default } from "./InputSwitch"
